import React from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';

import styles from './index.scss';

const I18nPrefix = 'strava.settings.partner_integrations.';
const I18nPrefixSelected = `${I18nPrefix}settings_changed.`;
const I18nKey = {
  enabled: `${I18nPrefix}enabled`,
  disabled: `${I18nPrefix}disabled`,
  seeYourActivities: `${I18nPrefix}see_your_activities`,
  selected: {
    enabled: {
      withDate: `${I18nPrefixSelected}enabled_with_date`,
      withoutDate: `${I18nPrefixSelected}enabled_without_date`
    },
    disabled: {
      withDate: `${I18nPrefixSelected}disabled_with_date`,
      withoutDate: `${I18nPrefixSelected}disabled_without_date`
    }
  }
};

export const getDescriptionString = (partnerName, value, date) => {
  if (value) {
    if (date) {
      return I18n.t(I18nKey.selected.disabled.withDate, {
        partnerName,
        date
      });
    }
    return I18n.t(I18nKey.selected.disabled.withoutDate, {
      partnerName
    });
  }
  if (date) {
    return I18n.t(I18nKey.selected.enabled.withDate, {
      partnerName,
      date
    });
  }
  return I18n.t(I18nKey.selected.enabled.withoutDate, {
    partnerName
  });
};

export const generateLink = (date) => {
  if (date) {
    return (
      <a href="/dashboard?feed_type=my_activity">
        {I18n.t(I18nKey.seeYourActivities)}
      </a>
    );
  }
  return null;
};

export const renderText = (selected, name, value, date) => {
  if (selected) {
    return (
      <div className={styles.description}>
        <p>{getDescriptionString(name, value, date)}</p>
        {generateLink(date)}
      </div>
    );
  }
  return null;
};

const OptOutSetting = ({ partner, partnerType, onChange, selected }) => (
  <div className={styles.optOutSection}>
    <div className={styles.partnerImageContainer}>
      <img
        className={styles.partnerImage}
        src={partner.profileImage}
        alt={partner.name}
      />
    </div>
    <div className={styles.partnerBody}>
      <h4 className={`text-subhead ${styles.partnerName}`}>
        {partner.partnerName}
      </h4>
      <form action="">
        <label className={styles.input}>
          <input
            type="radio"
            name={partner.partnerName}
            checked={!partner.value}
            disabled={partner.disabled}
            onChange={() => onChange({ ...partner, partnerType })}
          />
          <span className={styles.radioLabel}>{I18n.t(I18nKey.enabled)}</span>
        </label>
        <label className={styles.input}>
          <input
            type="radio"
            name={partner.partnerName}
            checked={partner.value}
            disabled={partner.disabled}
            onChange={() => onChange({ ...partner, partnerType })}
          />
          <span className={styles.radioLabel}>{I18n.t(I18nKey.disabled)}</span>
        </label>
      </form>
      {renderText(
        selected,
        partner.partnerName,
        partner.value,
        partner.lastActivityDate
      )}
    </div>
  </div>
);

OptOutSetting.propTypes = {
  onChange: PropTypes.func.isRequired,
  partnerType: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  partner: PropTypes.shape({
    name: PropTypes.string,
    disabled: PropTypes.bool,
    optOutName: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    profileImage: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    lastActivityDate: PropTypes.string
  }).isRequired
};

export default OptOutSetting;
